import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axiosInstance from "../axiosInterceptor";
import { toast } from "react-toastify";
import ReactPlayer from 'react-player';

const AddProjectVideo = () => {
    const navigator = useNavigate();
    const location = useLocation();
    const editData = location.state;
    const [projectData, setProjectData] = useState([]);

    const [data, setData] = useState({
        projectId: editData?.projectId?._id || "",
        position: editData?.position || "",
        desktopVideo: editData?.desktopVideo || "",
        videoLink: editData?.videoLink || "",
    });

    const [errors, setErrors] = useState({
        projectId: "",
        position: "",
        desktopVideo: "",
        videoLink: "",
    });

    const handleChange = (e) => {
        const { name, files, value } = e.target;
        if (name === "desktopVideo") {
            setData({ ...data, [name]: files.length > 0 ? files[0] : null });
        } else {
            setData({ ...data, [name]: value });
        }
        setErrors({ ...errors, [name]: "" });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        let hasErrors = false;

        // Validate email
        if (!data.projectId.trim()) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                projectId: "Project is required",
            }));
            hasErrors = true;
        }

        if (!data.position.trim()) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                position: "Position is required",
            }));
            hasErrors = true;
        }

        if (hasErrors) {
            return;
        }

        try {
            const formData = new FormData();
            formData.append("projectId", data.projectId);
            formData.append("position", data.position);
            formData.append("videoLink", data.videoLink);
            if (data.desktopVideo instanceof File) {
                formData.append("desktopVideo", data.desktopVideo);
            }

            const response = await axiosInstance.post(
                `project/createProjectVideo`,
                formData
            );
            if (response.status === 200) {
                toast.success(response.data.message);
                navigator("/project-video");
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            if (error.response) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Something went wrong. Please try again!!");
            }
        }
    };
    const handleUpdate = async (e) => {
        e.preventDefault();
        try {
            const formData = new FormData();
            formData.append("projectId", data.projectId);
            formData.append("position", data.position);
            formData.append("videoLink", data.videoLink);
            if (data.desktopVideo instanceof File) {
                formData.append("desktopVideo", data.desktopVideo);
            }

            const response = await axiosInstance.put(
                `project/updateProjectVideo/${editData?._id}`,
                formData
            );
            if (response.status === 200) {
                toast.success(response.data.message);
                navigator("/project-video");
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            if (error.response) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Something went wrong. Please try again!!");
            }
        }
    };

    const fetchData = async () => {
        try {
            const response = await axiosInstance.get(
                `project/getWithoutPaginationProject`
            );
            const { data } = response.data;
            setProjectData(data);
        } catch (error) {
            if (error.response) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Something went wrong. Please try again!!");
            }
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <>
            <div className="content-wrapper">
                <div className="page-header mt-5">
                    <h3 className="page-title">Add Project Video</h3>
                </div>
                <div className="row grid-margin stretch-card">
                    <div className="col-md-8  ">
                        <div className="card">
                            <div className="card-body">
                                <form
                                    className="pt-3"
                                    onSubmit={editData?._id ? handleUpdate : handleSubmit}
                                >
                                    <div className="form-group row">
                                        <label
                                            htmlFor="exampleInputUsername1"
                                            className="col-sm-3 col-form-label"
                                        >
                                            Project
                                        </label>
                                        <div className="col-sm-9">
                                            <select
                                                className="form-control form-control-lg"
                                                id="exampleFormControlSelect1"
                                                name="projectId"
                                                value={data.projectId}
                                                onChange={handleChange}
                                            >
                                                <option value="" disabled>
                                                    -- Please Select Project --
                                                </option>
                                                {projectData.map((item) => (
                                                    <option key={item._id} value={item._id}>
                                                        {item.title}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors.projectId && (
                                                <p className="text-danger">{errors.projectId}</p>
                                            )}
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label
                                            htmlFor="exampleInputUsername2"
                                            className="col-sm-3 col-form-label"
                                        >
                                            Position
                                        </label>
                                        <div className="col-sm-9">
                                            <input
                                                type="number"
                                                className="form-control form-control-sm"
                                                id="position"
                                                name="position"
                                                placeholder="Enter position"
                                                value={data.position}
                                                onChange={handleChange}
                                            />
                                            {errors.position && (
                                                <p className="text-danger">{errors.position}</p>
                                            )}
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label
                                            htmlFor="exampleInputUsername2"
                                            className="col-sm-3 col-form-label"
                                        >
                                            Video Link
                                        </label>
                                        <div className="col-sm-9">
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                id="videoLink"
                                                name="videoLink"
                                                placeholder="Enter link"
                                                value={data.videoLink}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label
                                            htmlFor="exampleInputUsername2"
                                            className="col-sm-3 col-form-label"
                                        >
                                            Video
                                        </label>
                                        <div className="col-sm-9">
                                            <input
                                                type="file"
                                                className="form-control form-control-sm"
                                                id="desktopVideo"
                                                name="desktopVideo"
                                                placeholder="Enter project img"
                                                // value={data.desktopVideo}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>

                                    <div className="text-center mt-4">
                                        <Link to="/project-video">
                                            <button className="btn btn-secondary mr-2">Back </button>
                                        </Link>
                                        <button type="submit" className="btn btn-success">
                                            Submit
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 stretch-card">
                        <div className="card">
                            {(data.desktopVideo || data.videoLink) && (
                                <div className="w-100 h-80 text-center mb-4">
                                    <p className="mt-3">Video Preview</p>
                                    {data.videoLink ? (
                                        <ReactPlayer
                                            url={data.videoLink}
                                            controls
                                            width="100%"
                                            height="100%"
                                            className="react-player px-4"
                                        />
                                    ) : (
                                        <video
                                            src={data.desktopVideo instanceof File ? URL.createObjectURL(data.desktopVideo) : data.desktopVideo}
                                            controls
                                            className="w-75"
                                        >
                                            Your browser does not support the video tag.
                                        </video>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AddProjectVideo;
